export default __webpack_public_path__ + "static/media/port-logo-locafacil.d63d196d.webp";